import type React from 'react';

interface SendButtonLoadingDotsProps {
    color?: string;
}

/**
 * Three bouncing dots animation for send button loading state.
 * Shows user that the system is processing and they cannot send yet.
 */
const SendButtonLoadingDots: React.FC<SendButtonLoadingDotsProps> = ({
    color = 'var(--rw-text-placeholder)',
}) => {
    return (
        <div className="flex items-center justify-center gap-[3px] w-6 h-6">
            <span
                className="w-[5px] h-[5px] rounded-full animate-bounce"
                style={{
                    backgroundColor: color,
                    animationDuration: '600ms',
                    animationDelay: '0ms',
                }}
            />
            <span
                className="w-[5px] h-[5px] rounded-full animate-bounce"
                style={{
                    backgroundColor: color,
                    animationDuration: '600ms',
                    animationDelay: '150ms',
                }}
            />
            <span
                className="w-[5px] h-[5px] rounded-full animate-bounce"
                style={{
                    backgroundColor: color,
                    animationDuration: '600ms',
                    animationDelay: '300ms',
                }}
            />
        </div>
    );
};

export default SendButtonLoadingDots;
